import { toast } from 'react-toastify';

import { uniqueId } from 'lodash';
import api from '../../api';

import { Board } from './types';

export async function getBoardByIdRequest(boardId: string) {
  try {
    const response = await api().get(`/boards/${boardId}`);

    return response;
  } catch (error) {
    console.error('Error GetBoardByIdRequest', error);
    return null;
  }
}

export async function getActiveBoardsByCompanyId(
  companyId: string,
  search: string,
  userId: string,
) {
  try {
    const response = await api().get(`/boards/active/${companyId}`, {
      params: {
        search,
      },
      headers: {
        userId,
      },
    });

    return response;
  } catch (error) {
    console.error('Error GetActiveBoardsByCompanyId', error);
    return null;
  }
}

export async function getArchiveBoardsByCompanyId(
  companyId: string,
  search: string,
  userId: string,
) {
  try {
    const response = await api().get(`/boards/arquive/${companyId}`, {
      params: {
        search,
      },
      headers: {
        userId,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error GetArchiveBoardsByCompanyId', error);
    return null;
  }
}

export async function createBoardRequest(
  board: Partial<Board>,
  userId: string,
  companyId: string,
) {
  try {
    const data = {
      ...board,
      status: 'BS1',
      user_id: userId,
    };
    const response = await api().post('/boards', data, {
      headers: {
        companyId,
        userId,
      },
    });

    toast.success('Board cadastrado com sucesso');
    return response;
  } catch (error: any) {
    console.error('Error CreateBoardRequest', error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function updateBoardRequest(
  board: Partial<Board>,
  boardId: string,
  userId: string,
  companyId: string,
) {
  try {
    const data = {
      ...board,
      user_id: userId,
    };
    const response = await api().patch(`/boards/${boardId}`, data, {
      headers: {
        companyId,
        userId,
      },
    });

    toast.success('Board editado com sucesso');
    return response;
  } catch (error: any) {
    console.error('Error UpdateBoardRequest', error);

    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function archiveBoardRequest(
  boardId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().patch(
      `/boards/remove/${boardId}`,
      {},
      {
        headers: { companyId, userId },
      },
    );

    toast.success('Board arquivado com sucesso');
    return response;
  } catch (error: any) {
    console.log('cancelBoardRequest error', error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function activeBoardRequest(
  boardId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().patch(
      `/boards/active/${boardId}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    toast.success('Board ativado com sucesso');
    return response;
  } catch (error: any) {
    console.log('activeBoardRequest error', error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}
